import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/community/CommunityClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
